import { TLocation } from "~/types";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import { CreateLocationParams, GetLocationParams, StorageSettings } from "./location.types";

export const locationServices = {
  getLocations: async (params?: GetLocationParams) => {
    const { data } = await baseService.get<PaginationResponse<TLocation>>(
      "locations",
      {
        params,
      }
    );
    return data;
  },
  createLocation: async (params: CreateLocationParams) => {
    const { data } = await baseService.post<TLocation>("locations", params);
    return data;
  },
  updateLocation: async (id: string, params: Partial<CreateLocationParams>) => {
    const { data } = await baseService.patch<TLocation>(
      `locations/${id}`,
      params
    );
    return data;
  },
  deleteLocation: async (id: string) => {
    await baseService.delete(`locations/${id}`);
  },
  getStorageSettings: async () => {
    const { data } = await baseService.get<StorageSettings>("storage/settings");
    return data;
  },
  updateStorageSettings: async (params: StorageSettings) => {
    const { data } = await baseService.patch<StorageSettings>(
      "storage/settings",
      params
    );
    return data;
  },
};
